import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from ".";
import { ICenterNotification, IBaseResponse, INotificationType, IAdminNotification } from "../models";
import { IPost } from './authorization';
import { IPut, IDelete } from './authorization/actions';

export const ActionTypes = {
    SET_CENTER_NOTIFICATIONS: 'SET_CENTER_NOTIFICATIONS'
}

export interface ICenterNotificationListResponse {
    data: {
        success: boolean,
        message: string,
        results: ICenterNotification[]
    }
}

export interface IAdminNotificationListResponse {
    data: {
        success: boolean,
        message: string,
        results: IAdminNotification[]
    }
}

export interface ICenterNotificationCreateResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            id: number;
            addedDateTime: string;
        }
    }
}

export interface INotificationLookupDataResponse {
    data: {
        success: boolean,
        results: INotificationType[]
    }
}

export const ActionCreators = {
    getAdminNotifications: () => async (dispatch: Dispatch<IApplicationState>): Promise<IAdminNotificationListResponse> => {
        let options = {
            url: `${__API__}/notification/admin`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },

    getCenterNotifications: (centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<ICenterNotificationListResponse> => {
        let options = {
            url: `${__API__}/notification/center?centerId=${centerId}`
        };

        let response = await dispatch(AuthActionCreators.apiGet(options));

        if (response.data.success) {
            dispatch(ActionCreators.setCenterNotifications(response.data.results));
        }

        return response;

        // try {
        //     const response = await dispatch(AuthActionCreators.apiGet(options)) as ICenterNotificationListResponse;

        //     if (response.data.success) {
        //         dispatch(ActionCreators.setCenterNotifications(response.data.results));
        //     }

        //     return await Promise.resolve(response);
        // } catch (error) {
        //     throw error;
        // }
    },

    getNotificationLookupData: () => async (dispatch: Dispatch<IApplicationState>): Promise<INotificationLookupDataResponse> => {
        let options = {
            url: __API__ + "/notification/lookup-data"
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },

    setCenterNotifications: (list: ICenterNotification[]) => {
        return {
            type: ActionTypes.SET_CENTER_NOTIFICATIONS,
            list
        };
    },

    createCenterNotification: (centerId: number, description: string, content: string, notificationTypeId: number, isEnabled: boolean) => async (dispatch: Dispatch<IApplicationState>): Promise<ICenterNotificationCreateResponse> => {
        let options: IPost = {
            url: `${__API__}/notification/center`,
            data: {
                id: 0,
                centerId,
                isEnabled,
                description,
                notificationText: content,
                notificationTypeId: notificationTypeId
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    updateCenterNotification: (id: number, centerId: number, description: string, content: string, notificationTypeId: number, isEnabled: boolean) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IPut = {
            url: `${__API__}/notification/center`,
            data: {
                id,
                centerId,
                isEnabled,
                description,
                notificationText: content,
                notificationTypeId
            }
        };

        return await dispatch(AuthActionCreators.apiPut(options));
    },
    deleteNotification: (id: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IDelete = {
            url: `${__API__}/notification/${id}`,
        }

        return await dispatch(AuthActionCreators.apiDelete(options));
    },
    markNotificationRead: (id: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IPost = {
            url: `${__API__}/notification/${id}/mark-read`,
        }

        return await dispatch(AuthActionCreators.apiPost(options));
    },
}

export interface ICenterNotificationState {
    list: ICenterNotification[]
}

var initialState: ICenterNotificationState = {
    list: []
};

interface ISetCenterNotifications {
    type: string,
    list: ICenterNotification[]
}

const setCenterNotifications = (state: ICenterNotificationState, action: ISetCenterNotifications) => {
    state.list = action.list;
    return state;
}

const createReducer = (initialState: ICenterNotificationState, handlers: any) => {
    return function reducer(state = initialState, action: any) {
        if (handlers.hasOwnProperty(action.type)) {
            let s = Object.assign({}, state);
            return handlers[action.type](s, action);
        } else {
            return state;
        }
    }
}

const handlers = {
    [ActionTypes.SET_CENTER_NOTIFICATIONS]: setCenterNotifications
};

export const Reducer = createReducer(initialState, handlers);
